import { Decoder, field, number, string, succeed } from 'jsonous';
import { resourceDecoder } from '../../Resource/Decoders';
import { Organization } from './Types';

export const organizationDecoder: Decoder<Organization> = succeed({})
  .assign('id', field('id', number))
  .assign('name', field('name', string));

export const organizationResourceDecoder = resourceDecoder(organizationDecoder);
